import wyRouter from './wangyue'
import hdRouter from './handi'
import hybridRouter from './hybrid'

export default (GLOBAL_FR === 'hd' ? hdRouter : (GLOBAL_FR === 'hybrid' ? hybridRouter : wyRouter))